import DocumentStorageTable from './DocumentStorageTable';
export default DocumentStorageTable;